import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IDashboardMidwifeResponse } from '../models/dashboard.models';

@Injectable({
  providedIn: 'root'
})
export class RatingService {

  constructor(private http: HttpClient) { }

  getMidwifeRating(body: any): Observable<IDashboardMidwifeResponse> {
    const url = `${environment.serverUrl}review/listformidwife`;
    return this.http.post<IDashboardMidwifeResponse>(url, body);
  }
}
